angular.module('bmsApp.employeeGroup')
	.factory('EmployeeGroupSvc', [
	'$rootScope',
	'$modal',
	'CRUDSvc', function (
			$rootScope,
			$modal,
			CRUDSvc) {

				function index(params) {
					return CRUDSvc.get('api/employeeGroup/index', params);
				}

				function save(params) {
					return CRUDSvc.post('api/employeeGroup/save', params);
				}

				function read(id) {
					return CRUDSvc.get('api/employeeGroup/read/' + id);
				}

				function options(id) {
					return CRUDSvc.get('api/employeeGroup/options');
				}

				function remove(id) {
					return CRUDSvc.get('api/employeeGroup/remove/' + id);
				}

				return {
					index: index,
					save: save,
					read: read,
					options: options,
					remove: remove,
					showEmployeeModal: function (group) {
						var modalEmployeeView = $modal.open({
							animation: true,
							templateUrl: 'ng/employee/employeeGroups/templates/EmployeeViewModal.html',
							controller: 'EmployeeViewModalCtrl',
							size: 'lg',
							scope: $rootScope,
							backdrop: 'static', // disable click-outside closing modal
							resolve: {
								group: function () {
									return angular.copy(group);
								}
							}
						});
					}
				};
	}]);
